export type NotificationGetPayload = {
    email : string;
    accountNumber: string;
}

export type NotificationDetails = {
    notificationSentToId : number;
    notificationContentId: number;
    accountNumber: string;
    userEmail: string;
    sentDate: string;
    readStatus: boolean;
    title: string;
    content: string;
}

export type NotificationDetailsState = {
    data: NotificationDetails[];
    loading: boolean;
    error: string | null;
}

export const initialState: NotificationDetailsState = {
    data: [],
    loading: false,
    error: null,
};

export type NotificationReadStatusPayload = {
    userEmail: string;
    notificationSentToId: number;
}

export type NotificationServiceOperators = {
    notificationList: NotificationDetails[];
    fetchAllNotifications: (data: NotificationGetPayload) => void;
};

export type NotificationReadStatusOperators = {
    message : string;
    AddNotificationReadStatus: (data: NotificationReadStatusPayload) => void;
};